import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
var VeltNotificationsPanelContentListItemAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-avatar-wireframe", __assign({}, transformedProps), children));
};
export default VeltNotificationsPanelContentListItemAvatarWireframe;
